import { render } from "./ClinicGroup.vue?vue&type=template&id=0e285bad&scoped=true"
import script from "./ClinicGroup.vue?vue&type=script&lang=js"
export * from "./ClinicGroup.vue?vue&type=script&lang=js"

import "./ClinicGroup.vue?vue&type=style&index=0&id=0e285bad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e285bad"]])

export default __exports__